module.exports = __webpack_public_path__ + "static/refresh-so-65fda9a9a27270ee9e9bc6d6f56236e6.png";